module.exports = __webpack_public_path__ + "media/images/email/delete_white-6ec604afba2160e671d190efe2f642aa.svg";